// extracted by mini-css-extract-plugin
export default {"moderationErrorItem":"FA2xnVFuGtFOel6pUABn","appealLink":"a2lxWdXAxgRplJA_m0CJ"};